import clientConfig from "@src/template/clientConfig";

const { SECURED_TOUCH_APP_ID, SECURED_TOUCH_APP_SECRET } = clientConfig.get();
export const initialiseSecuredTouch = (customerGuid, sessionId) => {
  function onSecuredTouchReady(callback) {
    if (window["_securedTouchReady"]) {
      callback();
    } else {
      document.addEventListener("SecuredTouchReadyEvent", callback);
    }
  }
  onSecuredTouchReady(() => {
    _securedTouch.init({
      url: "https://asos.securedtouch.com",
      appId: SECURED_TOUCH_APP_ID,
      appSecret: SECURED_TOUCH_APP_SECRET,
      username: customerGuid,
      sessionId: sessionId,
      isDebugMode: false
    });
  });
};
